import { forceInt } from '../functions';

$.widget('custom.hpaSelectmenu', $.ui.selectmenu, {
    _renderItem: function( ul, item ) {
		var li = $( "<li>" );

		if ( item.disabled ) {
			li.addClass( "ui-state-disabled" );
		}

        if (item.hidden) {
			li.addClass('hidden');
		} else if (li.hasClass('hidden')) {
            li.removeClass('hidden');
        }

		this._setText( li, item.label );

		return li.appendTo( ul );
	},
    _parseOptions: function( options ) {
		var data = [];
		options.each(function( index, item ) {
            let value = forceInt($(item).val()),
                hidden = false;
            if (value === 0) hidden = true;

			var option = $( item ),
				optgroup = option.parent( "optgroup" );
			data.push({
				element: option,
				index: index,
				value: option.attr( "value" ),
				label: option.text(),
				optgroup: optgroup.attr( "label" ) || "",
				disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" ),
                hidden: hidden
			});

		});
		this.items = data;
	},
    _setText: function(element, value) {
        if (value) {
            element.html(value);
        } else {
            // Invoke the parent widget's method of the same name.
            this._super(element, value);
        }
    },
});



// WEBPACK FOOTER //
// ./js/lib/hpa-jquery-ui-select.js